export default __webpack_public_path__ + "static/img-resource-102ec83a87923923b1b8b495a552a210.png";